// extracted by mini-css-extract-plugin
export default {"customField":"Input_customField__zg6Og","input":"Input_input__xt37y","placeholder":"Input_placeholder__f+eUT"};